var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.00001C0 16.0007 7.66319 19.5534 12.0583 14.6424C14.8756 11.5078 14.8756 6.49228 12.0583 3.3576C7.66319 -1.5534 0 1.99924 0 9.00001ZM15.4391 14.2245H13.1852C12.2836 15.3738 11.1567 16.3143 9.80439 16.9412C12.171 16.9412 13.974 16.0007 15.4391 14.2245ZM16.9041 10.8808H14.5375C14.3121 11.9258 13.974 12.8661 13.5233 13.5975H15.7772C16.3406 12.8661 16.6787 11.9258 16.9041 10.8808ZM13.1852 3.77556H15.4391C13.974 1.99924 12.171 1.05884 9.80439 1.05884C11.1567 1.68577 12.2836 2.62617 13.1852 3.77556ZM14.5375 7.11921H16.9041C16.6787 6.07432 16.3406 5.13391 15.7772 4.298H13.5233C13.974 5.13391 14.3121 6.07432 14.5375 7.11921ZM14.6502 7.64166V10.3584H17.0168V7.64166H14.6502Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFilled);
export default __webpack_public_path__ + "static/media/circleFilled.bc70da452730caf2e82baedf39139acb.svg";
export { ForwardRef as ReactComponent };